import { render, staticRenderFns } from "./ListMinhasFaturas.vue?vue&type=template&id=06179613&"
import script from "./ListMinhasFaturas.vue?vue&type=script&lang=js&"
export * from "./ListMinhasFaturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports